import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import moment from 'moment';
import {connect} from 'react-redux';
import * as Actions from 'actions';

class InteractionsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      message: {
        body: '',
        timestamp: '',
        editing: false
      }
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }


  componentWillUpdate() {
    this.scrollInteractionHistory();
  }

  onChange(e) {
    this.setState({
      message: {
        body: e.target.value,
        timestamp: Date.now(),
        client: this.props.client._id,
        editing: true,
        avatar: ''
      }
    });
  }

  onSubmit(e) {
    // Only submit on enter key or click.
    if (e.key !== 'Enter' && e.key !== undefined) return;

    e.preventDefault();

    this.setState({ message: { body: '', editing: false, timestamp: '' } });

    this.props.sendSocketEmit(this.state.message, 'client-interaction-new');
  }

  scrollInteractionHistory() {
    // Prevent the box from scrolling to bottom if user is creating an interaction
    // Could possibly be referencing data from an above interaction this could be annoying.
    if (this.state.message.editing) {
      return;
    }

    window.requestAnimationFrame(() => {
      const node = ReactDom.findDOMNode(this.refs.commentContainer);
      if (node != null) {
        node.scrollTop = node.scrollHeight;
      }
    });
  }

  render() {
    // Scroll on render via requestAnimationFrame.
    this.scrollInteractionHistory();

    return this.props.client && this.props.client.interactions ? (
      <div className="actionBox">
        <ul ref="commentContainer" style={{ maxHeight: this.props.height || 200 }} className="commentList">
          {(()=> {
            if (this.props.client.interactions.length <= 0) {
              return (
                <li className="animated fadeIn">

                  <div className="commentText">
                    <p className="">No recent interactions</p>
                  </div>
                </li>
              );
            }
          })()}
          {this.props.client.interactions.map((interaction, idx) => {
            const creator = `${interaction.created_by.name.first} ${interaction.created_by.name.last}`;
            const message = interaction.body;
            return (
              <li key={idx} className="animated fadeIn">
                <div className="commenterImage">
                  <img src={this.props.profile_picture ? this.props.profile_picture.url : this.props.avatar} />
                </div>
                <div className="commentText">
                  <p className="">{ message }</p> <span className="date sub-text">on {moment(interaction.created_at).format('MMM DD, YYYY hh:mm a')} by { creator }</span>
                </div>
              </li>
            );
          })}
        </ul>
        {(() => {
          // Enable / Disable creation for more basic views.
          if (this.props.enableCreate) {
            return (
              <section className="simple-compose-box mb-xlg">
                <form method="get" action="/">
                  <textarea onChange={this.onChange} value={this.state.message.body} name="message-text" data-plugin-textarea-autosize="" placeholder="Start typing.." rows="2"></textarea>
                  {/* <textarea onKeyPress={this.onSubmit} onChange={this.onChange} value={this.state.message.body} name="message-text" data-plugin-textarea-autosize="" placeholder="Start typing.." rows="2"></textarea> */}
                </form>
                <div className="compose-box-footer">
                  <ul className="compose-btn">
                    <li>
                      <div onClick={this.onSubmit} className="btn btn-primary btn-xs">Submit</div>
                    </li>
                  </ul>
                </div>
              </section>
            );
          }
        })()}
      </div>
    ) : (
      <p>No Client Selected</p>
    );
  }

}

InteractionsList.propTypes = {
  client : PropTypes.object
}

const mapStateToProps = ({ client, connection }) => ({ client, avatar : connection.user.avatar, profile_picture: connection.user.profile_picture });

export default connect(mapStateToProps, Actions)(InteractionsList);



// WEBPACK FOOTER //
// ./src/browser/components/client/interactions-list.js